import React, { useState, useEffect } from 'react';
import '../SitoLemir.css';
import { Phone, Mail, MapPin, ChevronDown, ArrowRight, Building2, HardHat, Wrench, CheckCircle2, Shield, Clock, Menu, X, Users, Award, Zap } from 'lucide-react';

const imgs = {
  hero: 'https://cdn.b12.io/client_media/GyICmsBS/44a61b77-2c01-11f1-8b94-0242ac110002-FD73EzjJMNqtS_G3zH_iJ.jpg',
  team: 'https://cdn.b12.io/client_media/GyICmsBS/44afaeb7-2c01-11f1-94cc-0242ac110002-Z8WE7P-vZ8127uyUZI92j.jpg',
  p1: 'https://cdn.b12.io/client_media/GyICmsBS/5cae5474-2c03-11f1-9434-0242ac110002--1LzilpbuxqT3YcSf9IAA.jpg',
  p2: 'https://cdn.b12.io/client_media/GyICmsBS/5c9671d9-2c03-11f1-9093-0242ac110002-XA2q16xyeV2ATuffKa3cA.jpg',
  p3: 'https://cdn.b12.io/client_media/GyICmsBS/5c7dcaf7-2c03-11f1-a7e2-0242ac110002-p98iIL7vmXPbfViBW-gp3.jpg',
  p4: 'https://cdn.b12.io/client_media/GyICmsBS/5ce09d06-2c03-11f1-a446-0242ac110002-Fh_l-Kb2418AcuoWL6Fnt.jpg',
  p5: 'https://cdn.b12.io/client_media/GyICmsBS/5cccfd4a-2c03-11f1-81fe-0242ac110002-T78_ge094-o0m-Y2QFEON.jpg',
  p6: 'https://cdn.b12.io/client_media/GyICmsBS/5cb33c18-2c03-11f1-9124-0242ac110002--TryeL8XxkjUlvvorDV7z.jpg',
};

const SitoLemir = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [formData, setFormData] = useState({ nome: '', email: '', telefono: '', tipo: '', messaggio: '' });
  const [formSent, setFormSent] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const scrollTo = (id) => { setMenuOpen(false); document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); };
  const handleSubmit = (e) => { e.preventDefault(); setFormSent(true); setTimeout(() => setFormSent(false), 5000); setFormData({ nome: '', email: '', telefono: '', tipo: '', messaggio: '' }); };

  return (
    <div className="lm">
      {/* NAV */}
      <nav className={`lm-nav ${scrolled ? 'lm-nav-solid' : ''}`}>
        <div className="lm-nav-inner">
          <div className="lm-brand" onClick={() => scrollTo('hero')}>
            <span className="lm-brand-name">LEMIR</span>
          </div>
          <div className={`lm-links ${menuOpen ? 'lm-links-open' : ''}`}>
            <button onClick={() => scrollTo('hero')}>Home</button>
            <button onClick={() => scrollTo('about')}>Chi siamo</button>
            <button onClick={() => scrollTo('services')}>Servizi</button>
            <button onClick={() => scrollTo('projects')}>Progetti</button>
            <button onClick={() => scrollTo('contact')}>Contatti</button>
          </div>
          <a href="#contact" className="lm-nav-cta" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>Contatti</a>
          <button className="lm-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? <X size={24} /> : <Menu size={24} />}</button>
        </div>
      </nav>

      {/* HERO */}
      <section id="hero" className="lm-hero">
        <div className="lm-hero-bg" style={{ backgroundImage: `url(${imgs.hero})` }} />
        <div className="lm-hero-overlay" />
        <div className="lm-hero-content">
          <h1 className="lm-hero-title">Lemir</h1>
          <p className="lm-hero-sub1">Società edile per lavori privati e pubblici</p>
          <p className="lm-hero-sub2">Costruzioni e ristrutturazioni moderne, sicure e affidabili.</p>
          <div className="lm-hero-btns">
            <button className="lm-btn-orange" onClick={() => scrollTo('contact')}>Richiedi un preventivo</button>
            <button className="lm-btn-outline" onClick={() => scrollTo('projects')}>Scopri i progetti</button>
          </div>
        </div>
        <button className="lm-scroll-down" onClick={() => scrollTo('about')}><ChevronDown size={28} /></button>
      </section>

      {/* CHI SIAMO */}
      <section id="about" className="lm-section lm-about">
        <div className="lm-container lm-about-grid">
          <div className="lm-about-text">
            <h2>Chi è Lemir</h2>
            <p>Lemir è una società edile specializzata in lavori di costruzione, ristrutturazione e manutenzione sia nel settore privato che pubblico. Con anni di esperienza, abbiamo sviluppato competenze distintive nel realizzare progetti complessi, mantenendo gli standard più alti di qualità e sicurezza.</p>
            <p>Il nostro team di professionisti qualificati lavora con dedizione per trasformare le visioni dei nostri clienti in realtà costruite, rispettando rigorosamente i tempi, i budget e le normative vigenti. Lemir è parte del <a href="/">Gruppo Colabella</a>, realtà consolidata nel settore delle costruzioni.</p>
            <div className="lm-checks">
              <div className="lm-check"><CheckCircle2 size={18} color="#1a365d" /> Esperienza consolidata in progetti pubblici e privati</div>
              <div className="lm-check"><CheckCircle2 size={18} color="#1a365d" /> Team di professionisti qualificati e certificati</div>
              <div className="lm-check"><CheckCircle2 size={18} color="#1a365d" /> Attenzione meticolosa a qualità e sicurezza</div>
            </div>
          </div>
          <div className="lm-about-img">
            <img src={imgs.team} alt="Team Lemir" />
          </div>
        </div>
      </section>

      {/* SERVIZI */}
      <section id="services" className="lm-section lm-services">
        <div className="lm-container">
          <h2 className="lm-section-title">I Nostri Servizi</h2>
          <p className="lm-section-sub">Offriamo soluzioni complete e personalizzate per ogni tipo di progetto edile</p>
          <div className="lm-services-grid">
            {[
              { icon: Building2, title: 'Lavori Edili per Privati', desc: 'Ristrutturazioni residenziali, nuove costruzioni, ampliamenti e interventi di qualità superiore per case e appartamenti moderni.' },
              { icon: HardHat, title: 'Opere Pubbliche', desc: 'Realizzazione di infrastrutture, edifici pubblici, scuole e interventi su patrimonio pubblico con piena conformità normativa.' },
              { icon: Wrench, title: 'Manutenzioni e Ristrutturazioni', desc: 'Interventi di manutenzione straordinaria, restauri conservativi e adeguamenti normativi per edifici di qualsiasi epoca.' },
            ].map((s, i) => (
              <div key={i} className="lm-service-card">
                <div className="lm-service-icon"><s.icon size={28} /></div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROGETTI */}
      <section id="projects" className="lm-section lm-projects">
        <div className="lm-container">
          <h2 className="lm-section-title">I Nostri Progetti</h2>
          <p className="lm-section-sub">Una selezione di lavori realizzati in ambito privato e pubblico</p>
          <div className="lm-projects-grid">
            {[
              { img: imgs.p1, title: 'Residenza Privata', cat: 'Settore Privato', desc: 'Complesso residenziale moderno con 40 unità abitative' },
              { img: imgs.p2, title: 'Struttura Ospedaliera', cat: 'Settore Pubblico', desc: 'Ospedale moderno con strutture sanitarie innovative' },
              { img: imgs.p3, title: 'Centro Commerciale', cat: 'Settore Privato', desc: 'Centro commerciale di 25.000 mq con interni premium' },
              { img: imgs.p4, title: 'Edificio Pubblico', cat: 'Settore Pubblico', desc: 'Complesso amministrativo e istituzionale' },
              { img: imgs.p5, title: 'Cantiere in Corso', cat: 'Settore Privato', desc: 'Nuova costruzione residenziale moderna e sostenibile' },
              { img: imgs.p6, title: 'Infrastruttura Moderna', cat: 'Settore Pubblico', desc: 'Parcheggio moderno con tecnologie intelligenti' },
            ].map((p, i) => (
              <div key={i} className="lm-project-card">
                <img src={p.img} alt={p.title} />
                <div className="lm-project-info">
                  <span className="lm-project-cat">{p.cat}</span>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PERCHÉ */}
      <section className="lm-section lm-why">
        <div className="lm-container">
          <div className="lm-why-grid">
            <div className="lm-why-img" style={{ backgroundImage: `url(${imgs.team})` }} />
            <div className="lm-why-content">
              <h2>Perché Scegliere Lemir</h2>
              <div className="lm-why-list">
                {[
                  { icon: Award, title: 'Esperienza Consolidata', desc: 'Anni di operatività in progetti pubblici e privati di grande complessità.' },
                  { icon: Shield, title: 'Qualità Certificata', desc: 'Conformità a tutte le normative, certificazioni ISO e standard internazionali.' },
                  { icon: Clock, title: 'Rispetto di Tempi e Budget', desc: 'Gestione rigorosa del cronoprogramma e dei costi, con totale trasparenza.' },
                  { icon: Zap, title: 'Innovazione Tecnologica', desc: 'Metodologie moderne, BIM, sostenibilità e soluzioni costruttive all\'avanguardia.' },
                  { icon: Users, title: 'Sicurezza Prioritaria', desc: 'Massima attenzione alla sicurezza dei cantieri e al benessere dei lavoratori.' },
                ].map((w, i) => (
                  <div key={i} className="lm-why-item">
                    <div className="lm-why-icon"><w.icon size={20} /></div>
                    <div><h4>{w.title}</h4><p>{w.desc}</p></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTATTI */}
      <section id="contact" className="lm-section lm-contact">
        <div className="lm-container lm-contact-grid">
          <div className="lm-contact-info">
            <h2>Contatta Lemir</h2>
            <p>Richiedi informazioni o un preventivo per lavori edili privati o pubblici.</p>
            <div className="lm-contact-items">
              <a href="tel:+393202711608" className="lm-contact-item"><Phone size={20} /><div><h4>Telefono</h4><p>+39 320 271 1608</p><span>Lun-Ven, 8:00-18:00</span></div></a>
              <a href="mailto:info@lemircc.com" className="lm-contact-item"><Mail size={20} /><div><h4>Email</h4><p>info@lemircc.com</p><span>Risposta entro 24 ore</span></div></a>
              <div className="lm-contact-item"><MapPin size={20} /><div><h4>Indirizzo</h4><p>Via Alba 1</p><span>86046 San Martino in Pensilis (CB)</span></div></div>
            </div>
          </div>
          <form className="lm-form" onSubmit={handleSubmit}>
            <input placeholder="Nome *" required value={formData.nome} onChange={e => setFormData({...formData, nome: e.target.value})} />
            <input type="email" placeholder="Email *" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} />
            <input type="tel" placeholder="Telefono *" value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})} />
            <select value={formData.tipo} onChange={e => setFormData({...formData, tipo: e.target.value})}>
              <option value="">Tipologia di lavoro *</option>
              <option value="privati">Lavori privati</option>
              <option value="pubblici">Opere pubbliche</option>
              <option value="manutenzioni">Manutenzioni</option>
              <option value="ristrutturazioni">Ristrutturazioni</option>
            </select>
            <textarea placeholder="Messaggio *" rows={4} value={formData.messaggio} onChange={e => setFormData({...formData, messaggio: e.target.value})} />
            <button type="submit" className="lm-btn-orange lm-btn-full">{formSent ? 'Richiesta Inviata!' : 'Invia Richiesta'}</button>
          </form>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="lm-footer">
        <div className="lm-container lm-footer-inner">
          <div><span className="lm-footer-brand">LEMIR</span><p>Società edile — Parte del Gruppo Colabella</p></div>
          <div className="lm-footer-links">
            <button onClick={() => scrollTo('about')}>Chi siamo</button>
            <button onClick={() => scrollTo('services')}>Servizi</button>
            <button onClick={() => scrollTo('projects')}>Progetti</button>
            <button onClick={() => scrollTo('contact')}>Contatti</button>
          </div>
          <div className="lm-footer-contact">
            <p><Phone size={13} /> +39 320 271 1608</p>
            <p><Mail size={13} /> info@lemircc.com</p>
            <p><MapPin size={13} /> San Martino in Pensilis (CB)</p>
          </div>
        </div>
        <div className="lm-footer-bottom"><p>&copy; {new Date().getFullYear()} Lemir S.r.l. — Gruppo Colabella — Tutti i diritti riservati</p></div>
      </footer>
    </div>
  );
};

export default SitoLemir;
